const initPhoneVerification = require('@/customer/authentication/authentication-phone-verification')
  .init;

const GOOGLE_CAPTCHA = 'googlerecaptcha';
const URL_PARAMS_TO_KEEP_ON_REDIRECTION = ['orderId', 'returnId', 'refundId'];
const RECOVER_DATA_ONLY_MOBILE = 'recover-data-only-mobile-option';
const DATA_STORE_KEY = 'mainIdentifier';

const services = {
  LOGIN: 'rest/model/atg/userprofiling/ProfileActor/login',
  CHECK_IDENTIFIER:
    'rest/model/atg/userprofiling/ProfileActor/isIdentifierExists',
  RECOVER_DATA: '/rest/model/atg/userprofiling/ProfileActor/recover-data',
};

const captchaParams = {};
let form;
let formContent;
let $form;
let currentLogin;
let login;
let validate;
let type;
let fields = [];
let captcha;
let recaptcha;
let params = {};
let isCaptchaEnabled;
let isCaptchaInvisible;
let rules;
let itIsMyMobile;

const loginModule = {
  init() {
    // rules and expressCheckout needs to be calculated in init function after reload cartridge (ex : in express checkout)
    form = cube.$id('login-form');
    rules = initRules();
    login = cube.$id('login');
    validate = cube.$id('validate-block');
    captcha = cube.$id('captcha-block');
    recaptcha = form.$('.g-recaptcha');
    itIsMyMobile = cube.$id('it-is-my-mobile-block');
    type = cube.$id('captcha-type') && cube.$id('captcha-type').value;
    isCaptchaEnabled =
      cube.$id('captcha-on-login') &&
      cube.$id('captcha-on-login').value === 'true';
    isCaptchaInvisible =
      cube.$id('captcha-invisible') &&
      cube.$id('captcha-invisible').value === 'true';

    cube.lazyLoadCaptcha();

    if (recaptcha) {
      if (!window.grecaptcha)
        cube.event.on('captcha-loaded', () => {
          recaptcha.dataset.id = window.grecaptcha.render(recaptcha);
        });
      else recaptcha.dataset.id = window.grecaptcha.render(recaptcha);
    }

    loginModule.setRules();
    loginModule.events();
  },

  events() {
    const link = cube.$id('forgot-password-link');
    if (link) link.addEventListener('click', loginModule.setURLHashParameter);

    const linkOnlyMobile = cube.$id('recover-data-only-mobile-link');
    if (linkOnlyMobile)
      linkOnlyMobile.addEventListener('click', loginModule.setURLHashParameter);

    const readMore = cube.$id('it-is-my-mobile-read-more');
    if (readMore)
      readMore.addEventListener('click', loginModule.toggleMobileTips);

    const mobileLink = cube.$id('it-is-my-mobile-link');
    if (mobileLink)
      mobileLink.addEventListener('click', loginModule.itsMyMobile);

    const continueWithoutLogInLink = cube.$id('continue-without-login-link');
    if (continueWithoutLogInLink)
      continueWithoutLogInLink.addEventListener(
        'click',
        loginModule.continueWithoutLogin
      );

    login.addEventListener('input', () => {
      formContent.removeAttribute('style');
    });

    form.addEventListener('submit', e => {
      e.preventDefault();

      formContent.removeAttribute('style');

      const buttons = form.$tag('button');

      buttons.forEach(button => {
        // trigger the correct event according to the visible button //
        if (button.offsetParent) {
          if (button.classList.contains('validate-button')) {
            if (isCaptchaEnabled && isCaptchaInvisible && $form.valid())
              window.grecaptcha.execute(recaptcha.dataset.id);
            else loginModule.checkLogin(button);
          }

          if (button.classList.contains('sign-in-button'))
            loginModule.login(button);

          if (button.classList.contains('recover-data-button'))
            loginModule.recoverData(button);
        }
      });
    });
  },

  itsMyMobile(event) {
    event.preventDefault();

    params = sessionStorage.getItem(DATA_STORE_KEY)
      ? JSON.parse(sessionStorage.getItem(DATA_STORE_KEY))
      : {};

    params.itsMyMobile = true;

    sessionStorage.setItem(DATA_STORE_KEY, JSON.stringify(params));

    loginModule.redirectToCreateAccountPage();
  },

  continueWithoutLogin(event) {
    event.preventDefault();

    params = JSON.parse(sessionStorage.getItem(DATA_STORE_KEY));
    params.continueWithoutLogIn = true;

    sessionStorage.removeItem(DATA_STORE_KEY);
    sessionStorage.setItem(DATA_STORE_KEY, JSON.stringify(params));

    window.location.href = event.target.href;
  },

  setRules() {
    formContent = cube.$('.login-form__content');
    $form = $(form);
    $form.validate(rules);
  },

  setURLHashParameter() {
    this.href = `${this.href}#login=${encodeURIComponent(params.login)}${
      params.countryCode ? `&countryCode=${params.countryCode}` : ''
    }`;
    loginModule.enable(this, false);
  },

  checkLogin() {
    const country = form.$('[name=countryCode]');
    let valid = true;

    // check if captcha is valid //
    if (isCaptchaEnabled && !window.decathlon.captcha.isCaptchaChecked) {
      if (captcha) captcha.classList.add('has-error');
      valid = false;
    }

    if ($form.valid() && valid) {
      sessionStorage.removeItem(DATA_STORE_KEY);

      loginModule.enable(formContent, false);

      params.login = login.value;
      params.countryCode = country ? country.value : null;

      cube.ajax
        .post(
          services.CHECK_IDENTIFIER,
          Object.assign(
            {
              isCheckout: form.hasAttribute('data-is-checkout') || false,
              process: 'login',
            },
            captchaParams,
            params
          )
        )
        .onSuccess(loginModule.checkLoginSuccess)
        .onError(response => {
          loginModule.enable(formContent, true);
          loginModule.serviceError(response);
          if (window.decathlon.captcha) {
            window.decathlon.captcha.resetCaptcha();
          }
        })
        .call();
    }
  },

  checkLoginSuccess(response) {
    if (response.responseTO && response.responseTO.errors.length) {
      if (window.decathlon.captcha) window.decathlon.captcha.resetCaptcha();
      loginModule.serviceError(response);
      loginModule.enable(formContent, true);
    } else {
      const { data } = response.responseTO;

      if (data.identifierExists) {
        if (data.randomPassword) {
          cube.$id('forgot-password-link').click();
        } else {
          currentLogin = login.value;
          login.addEventListener('keyup', loginModule.updateLogin);

          if (!data.loginAuthorized && [3, 4].includes(data.memberType)) {
            const validator = $form.validate();

            validator.showErrors({
              login: window.Messages(
                'login.identifier.error.invalid_identifier'
              ),
            });

            currentLogin = login.value;

            loginModule.enable(formContent, true);
            loginModule.show(itIsMyMobile, true);
            fields.push(itIsMyMobile);

            params.identifierType = data.identifierType;
            sessionStorage.setItem(DATA_STORE_KEY, JSON.stringify(params));

            return;
          }

          // set default form height //
          formContent.style.height = `${formContent.offsetHeight}px`;
          loginModule.show(validate, false);

          if (captcha) loginModule.show(captcha, false);

          // display fields //
          loginModule.getProcess(data);

          // set new form height //
          formContent.style.height = `${formContent.scrollHeight}px`;
          // wait the css animation end and enable form //
          setTimeout(() => {
            loginModule.enable(formContent, true);
            formContent.removeAttribute('style');
          }, 400);
        }
      }

      params.identifierType = data.identifierType;
      sessionStorage.setItem(DATA_STORE_KEY, JSON.stringify(params));

      if (!data.identifierExists) {
        loginModule.redirectToCreateAccountPage();
      }
    }
  },

  updateLogin() {
    if (currentLogin !== this.value) {
      formContent.style.height = `${formContent.offsetHeight}px`;

      loginModule.enable(formContent, false);
      loginModule.show(fields, false);

      if (window.decathlon.captcha) window.decathlon.captcha.resetCaptcha();

      const password = cube.$id('password-block');
      password.value = '';

      if (password.classList.contains('has-error'))
        password.classList.remove('has-error');

      setTimeout(() => {
        let height = 0;

        const margin = parseFloat(
          getComputedStyle(validate).marginBottom.replace('px', '')
        );

        height += cube.$id('login-block').offsetHeight + margin;

        loginModule.show(validate, true);
        height += validate.offsetHeight + margin;

        if (captcha) {
          loginModule.show(captcha, true);
          height += captcha.offsetHeight + margin;
        }

        if (itIsMyMobile.offsetParent) {
          height += itIsMyMobile.offsetHeight + margin;
        }

        formContent.style.height = `${height}px`;
        loginModule.enable(formContent, true);
      }, 400);

      login.removeEventListener('keyup', loginModule.updateLogin);
    }
  },

  login(button) {
    if (
      (captcha && window.decathlon.captcha.isCaptchaChecked && $form.valid()) ||
      $form.valid()
    ) {
      button.disabled = true;

      cube.ajax
        .post(
          services.LOGIN,
          Object.assign({}, captchaParams, loginModule.getParameters(form))
        )
        .onSuccess(response => {
          loginModule.loginSuccess(response, button);
        })
        .onError(response => {
          button.disabled = false;
          loginModule.serviceError(response);
          window.decathlon.captcha.resetCaptcha();
          loginModule.resetForm();
        })
        .call();
    }
  },

  expressCheckoutLoginsuccess(response, button) {
    if (response.responseTO && response.responseTO.errors.length) {
      button.disabled = false;
      loginModule.serviceError(response);
      window.decathlon.captcha.resetCaptcha();
    } else {
      CUBE.Personalization.forceSendPersonalization();

      document.dispatchEvent(new CustomEvent('expressCheckoutLoginSuccess'));

      cube
        .cartridge('header-my-account')
        .after(() => {
          $('#dropdown-account').uxHeaderDropdownFunctions();
          cube.event.send('reload-header-my-account');
        })
        .reload();
    }
  },

  resetForm() {
    formContent.style.height = `${formContent.offsetHeight}px`;

    loginModule.enable(formContent, false);
    loginModule.show(fields, false);

    if (window.decathlon.captcha) window.decathlon.captcha.resetCaptcha();

    const password = cube.$id('password-block');
    password.value = '';

    if (password.classList.contains('has-error'))
      password.classList.remove('has-error');

    setTimeout(() => {
      const margin = parseFloat(
        getComputedStyle(validate).marginBottom.replace('px', '')
      );
      let height = 0;

      loginModule.show([captcha, validate], true);

      height +=
        cube.$id('login-block').offsetHeight +
        (captcha ? captcha.offsetHeight + margin : 0) +
        (itIsMyMobile ? itIsMyMobile.offsetHeight + margin : 0) +
        validate.offsetHeight;

      formContent.style.height = `${height}px`;
      loginModule.enable(formContent, true);
    }, 400);
  },

  loginSuccess(response, button) {
    if (response.responseTO && response.responseTO.errors.length) {
      button.disabled = false;
      loginModule.serviceError(response);
      if (window.decathlon && window.decathlon.captcha) {
        window.decathlon.captcha.resetCaptcha();
      }
      loginModule.resetForm();
    }
    // Express checkout login process //
    else if (cube.$id('express-checkout-panel')) {
      CUBE.Personalization.forceSendPersonalization();

      document.dispatchEvent(new CustomEvent('expressCheckoutLoginSuccess'));

      cube
        .cartridge('header-my-account')
        .after(() => {
          $('#dropdown-account').uxHeaderDropdownFunctions();
          cube.event.send('reload-header-my-account');
        })
        .reload();
    }
    // Regular login process //
    else {
      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.queue.send('analyticsLoginEvent');
        CUBE.Personalization.forceSendPersonalization();
      }
      if (!response.responseTO.data.activateMobileValidation) {
        loginModule.redirectToDashboard(response);
      } else {
        const { isModalDisposable } = response.responseTO.data;

        initPhoneVerification(isModalDisposable, () =>
          loginModule.redirectToDashboard(response)
        );
      }
    }
  },

  recoverData(button) {
    button.disabled = true;

    cube.ajax
      .post(services.RECOVER_DATA, loginModule.getParameters(form))
      .onSuccess(response => {
        loginModule.recoverDataSuccess(response, button);
        button.disabled = false;
      })
      .onError(response => {
        button.disabled = false;
        loginModule.serviceError();
      })
      .call();
  },

  recoverDataSuccess(response) {
    if (response.responseTO && response.responseTO.errors.length)
      loginModule.serviceError(response);
    else
      cube.alert.success(
        window.Messages('createAccount.completeAccountEmailSuccessMessage')
      );

    loginModule.updateLogin();
  },

  enable(element, enable) {
    const classes = element.classList;

    if (enable) classes.remove('disabled');
    else classes.add('disabled');
  },

  getProcess(data) {
    const ENGAGED = [3, 4];
    const SMART = [2, 6];
    const types = {
      engaged: [
        cube.$id('password-block'),
        cube.$id('remember-me-block'),
        cube.$id('signin-block'),
        cube.$id('forgot-password-link'),
      ],
      smart: [cube.$id('recover-data-block')],
      smartOnlyMobile: [cube.$id('recover-data-only-mobile-block')],
      checkout: [
        cube.$id('login-form-separator'),
        cube.$id('continue-without-login-block'),
      ],
    };
    const { memberType } = data;

    fields = [];

    if (ENGAGED.includes(memberType) || SMART.includes(memberType)) {
      if (ENGAGED.includes(memberType)) {
        fields = types.engaged;
      } else if (
        data.options &&
        data.options.includes(RECOVER_DATA_ONLY_MOBILE)
      )
        fields = types.smartOnlyMobile;
      else fields = types.smart;

      //Add option "itsMyMobile" if it's an existing mobile
      if (data.identifierType === 'MOBILE')
        fields.push(cube.$id('it-is-my-mobile-block'));

      if (form.hasAttribute('data-is-checkout') && data.processAuthorize)
        fields = fields.concat(types.checkout);

      loginModule.show(fields, true);
    } else {
      loginModule.redirectToCreateAccountPage();
    }
  },

  show(_elements, show) {
    const elements = Array.isArray(_elements) ? _elements : [_elements];

    if (show) {
      elements.forEach(element => {
        if (element) element.classList.remove('hidden');
      });
    } else {
      elements.forEach(element => {
        element.classList.add('hidden');
      });
    }
  },

  serviceError(response) {
    if (response.responseTO)
      cube.alert.error(window.Messages(response.responseTO.errors[0].code));
    else if (response.error) cube.alert.error(response.error.message);
  },

  redirectToCreateAccountPage() {
    window.location.href = form.dataset.createPageUrl;
  },

  redirectToDashboard(response) {
    const url = window.location.search.substring(1);
    let redirectUrl = null;

    if (
      response &&
      response.responseTO &&
      response.responseTO.data &&
      response.responseTO.data.url
    ) {
      redirectUrl = response.responseTO.data.url;
    } else if (url.indexOf('redirectUrl=') > -1) {
      let endIndex;

      if (url.indexOf('&') > -1) endIndex = url.indexOf('&');
      else endIndex = url.length;

      redirectUrl = url.substring(url.indexOf('redirectUrl=') + 12, endIndex);
    }

    if (redirectUrl !== null && redirectUrl !== undefined) {
      const r = new RegExp('^(?:[a-z]+:)?//', 'i');

      if (!r.test(redirectUrl)) {
        // Retrieve specifics parameters in the URL and add them to the redirection
        URL_PARAMS_TO_KEEP_ON_REDIRECTION.forEach(parameter => {
          const specificParam = window.getURLParameter(parameter);

          if (specificParam)
            redirectUrl = window.addURLParameter(
              redirectUrl,
              parameter,
              specificParam
            );
        });

        // Defect 11230 : login url should not be stored in browser's history
        window.location.replace(redirectUrl);
      } else if (window.location.pathname.indexOf('/wechat/') > -1)
        window.location.replace(redirectUrl);
      else window.location.href = '/';
    } else if (window.location.pathname.match(/checkout\/login/)) {
      window.location.href = window.location.pathname.replace('login', 'cart');
    } else {
      //define the redirect url with normal login process
      window.location.href = form.dataset.redirectUrl;
    }
  },

  getParameters(_form) {
    const inputs = _form.elements;
    const data = {};

    inputs.forEach(input => {
      if (
        input.name &&
        (input.type === 'select-one' ||
          ((input.type === 'checkbox' || input.type === 'radio') &&
            input.checked) ||
          input.type === 'hidden' ||
          input.offsetParent)
      )
        data[input.name] = input.value;
    });

    return data;
  },

  toggleMobileTips(e) {
    e.preventDefault();

    const target = cube.$id(this.dataset.target);
    const classes = target.classList;

    if (classes.contains('hidden')) classes.remove('hidden');
    else classes.add('hidden');
  },
};

function initRules() {
  return Object.assign($.validator.cubeOptions, {
    rules: {
      login: {
        maxlength: 100,
        mobile: {
          depends: element => element.classList.contains('login-mobile'),
        },
        email: {
          depends: element => element.classList.contains('login-email'),
        },
        emailmobile: {
          depends: element => element.classList.contains('login-both'),
        },
      },
      password: {
        extendedspecialcaracters: true
      }
    },
    ignore: ':hidden:not(.selectpicker)',
    unhighlight: (element, error, valid) => {
      const parent = element.closest('.form-group');
      const { classList } = parent;

      classList.remove(error);

      if (element.value.length && valid) classList.add(valid);
    },
  });
}

//global scope //
window.setCaptchaChecked = responseToken => {
  window.decathlon.captcha.isCaptchaChecked = true;
  if (type === GOOGLE_CAPTCHA)
    captchaParams['g-recaptcha-response'] = responseToken;
  else captchaParams.luotest_response = responseToken;

  captchaParams[window.decathlon.captcha.isCaptchaInvisibleTag] =
    window.decathlon.captcha.isCaptchaInvisible;

  if (captcha) captcha.classList.remove('has-error');
  if (isCaptchaEnabled && isCaptchaInvisible) loginModule.checkLogin();
};

window.setCaptchaUnchecked = () => {
  window.decathlon.captcha.isCaptchaChecked = false;
};

module.exports = loginModule;



// WEBPACK FOOTER //
// ./src/modules-es5/authentication/login/login.js